import { render } from "./MiniWizardStickyHeader.vue?vue&type=template&id=45fc7266"
import script from "./MiniWizardStickyHeader.vue?vue&type=script&lang=js"
export * from "./MiniWizardStickyHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__